import React, { Component } from "react";
import {Form }  from 'react-bootstrap'
import {fetchToken} from '../../Util.js';
import { reactAI } from "react-appinsights";
import uuid from 'react-native-uuid';
import {appInsights} from '../../common/AppInsights/AppInsights';
import {SERVICE_NAME,SERVICE_OFFERING,COMPONENT_NAME,SERVICE_LINE,COMPONENT_ID} from "../../common/Constants/Constants";
import { event } from "jquery";

export class ReactEventStatusDropDown extends Component{

    constructor(){
        super()        
        this.state={eventstatus:[],selectedStatus:null}
    }

    handleStatusChange = async(status) => {
         this.setState({ selectedStatus:status.target.value})
         await this.props.newstatus(status.target.value);
       };

    async componentDidMount() {
      
        appInsights.trackTrace({ message: 'Status Component Loaded.' },
                     {
                         userName: this.props.email,
                         "ComponentId" : COMPONENT_ID,
                         "ComponentName" : COMPONENT_NAME,
                         "EnvironmentName" : window.env.ENVIRONMENT,
                         "ServiceLineName" : SERVICE_LINE,
                         "ServiceName" : SERVICE_NAME,
                         "ServiceOfferingName" : SERVICE_OFFERING,
                         "Correlation Id": uuid.v1(),
                         "Component": 'Status Page',
                     });
        var token = await fetchToken();
        var correlationId = uuid.v1();
        var bearer = 'Bearer ' + token;
        var apimUrl = window.env.APIMURL + "/api/outage/getstatusmappings";
        fetch(apimUrl,{
            method: 'GET',
            headers: {
                'authorization': bearer,
                'Accept' : 'application/json',
                'CorrelationId': correlationId,
                'Content-Type': 'application/json'
            }})
          .then(response => {
            return response.json();
          })        
          .then(data => {   
                     
              this.setState({ eventstatus:data
              });
            })
            .catch(error => {
                var err = 
                {
                 "message": "Exception occured in Status page while getting the Status Mappings from the DB",
                 "ComponentId" : COMPONENT_ID,
                 "ComponentName" : COMPONENT_NAME,
                 "EnvironmentName" : window.env.ENVIRONMENT,
                 "ServiceLineName" : SERVICE_LINE,
                 "ServiceName" : SERVICE_NAME,
                 "ServiceOfferingName" : SERVICE_OFFERING,
                 "Component": 'Status Page',
                 "userName": this.props.email,                   
                 "exception": error.message,
                 "Correlation Id": correlationId,
                }
                appInsights.trackException({exception: error,properties : err});
            })
        
    }

        render(){       
        return(          
            <div>
            <label htmlFor="outageTitle">Status</label>
            <Form.Control id="status" title="Select Group" as="select" value = {this.state.selectedStatus == null || "" ? this.props.status :this.state.selectedStatus} 
            onChange={this.handleStatusChange}>                   
                <option value={null}>--Select Status--</option>
                {                    
                    [...new Set(this.state.eventstatus.map((x)=>x.status))].map((todo, index) => <option key={index} value={todo} as="select" >{todo}</option> )
                }
            </Form.Control>
            
        </div>  
        )      
    }
}

export default ReactEventStatusDropDown;